'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';

  if (!Component) {
    return fallback;
  }
  return Component.displayName || Component.name || fallback;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.47/js/getComponentName.js
// module id = 155
// module chunks = 0